import * as fb from '@/plugins/firebase'
import {ROUTE_PATHS, router} from '@/router'
import UserService from "@/service/user.service";

export const state = {
    user: {},
    userProfile: {}

}

export const getters = {
    getUser(state) {
        return state.user
    },
    getUserProfile(state) {
        return state.userProfile
    },

}

export const mutations = {
    setUser(state, val) {
        state.user = val
    },
    setUserProfile(state, val) {
        state.userProfile = val
    },

}

export const actions = {
    async login({dispatch, commit}, form) {
        // sign user in
        let {signedUser} = await fb.auth.signInWithEmailAndPassword(form.email, form.password)

        let fbUser = null

        if (!signedUser) {
            fbUser = fb.auth.currentUser;
        }

        if (fbUser) {
            await dispatch('loadProfile', fbUser)

            // set user data
            commit("setUser", fbUser);


            // change route to dashboard
            await router.push(ROUTE_PATHS.HOME)
        }
    },
    async logout({commit}) {
        await fb.auth.signOut();

        commit('setUserProfile', null)

        await router.push(ROUTE_PATHS.LOGIN)
    },
    async loadProfile({commit}, fbUser){
        if (!fbUser) {
            fbUser = fb.auth.currentUser;
        }

        let userProfile = await UserService.loadInternal({email: fbUser.email});

        if(!userProfile) {
            await fb.auth.signOut();

            throw new Error("user not found")
        }

        if(userProfile.blocked) {
            await fb.auth.signOut();

            throw new Error("user is blocked")
        }

        commit("setUserProfile", userProfile);
    }
}

export default {
    state,
    actions,
    mutations,
};